import axios from "axios";
import { getHeaders } from "../../config/auth/auth";

// const { REACT_APP_URL_API } = process.env;
const url: any = process.env.REACT_APP_URL_API;
const relativeUrl: any = process.env.REACT_APP_RELATIVE_URL_API;

export const Httpscommon = axios.create({
  baseURL: url,
  headers: {
    "Content-type": "application/json"
  },
});

Httpscommon.interceptors.request.use(
  async (config: any) => {

    const headers = await getHeaders(config.method.toUpperCase(), relativeUrl+config.url);
    // console.log(headers)

    return { ...config, headers };
  },
  (error) => Promise.reject(error)
);
